/**
 * @typedef {{handle:string, variant: string, price: number, imageUrl: string, hasBasicColors: boolean, title:string}} Favourite
 */

(function () {
  const viewingHistory = {
    fetchRecentlyVisitedProducts(page, perPage = 20) {
      return fetch(
        `${mainPoint}recently-viewed?page=${page}&customerId=${_customerId}&date=${tokenDate}&perPage=${perPage}`,
        {
          headers: {
            "X-Shopify-Token": token,
          },
        }
      ).then((res) => res.json());
    },
    saveRecentlyVisitedProductInDB(handle, queryParams = "") {
      return fetch(`${mainPoint}recently-viewed`, {
        ...fetchConfig(),
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Token": token,
        },
        method: "POST",
        body: JSON.stringify({
          pageHandle: handle,
          queryParam: String(queryParams),
          data: {
            userId: Number(_customerId),
            date: String(tokenDate),
          },
        }),
      }).catch(() => {});
    },
    getRecentlyVisitedItemsFromStorage() {
      return JSON.parse(localStorage.getItem("recently-visited-guest") || "[]");
    },
    /**
     * @param {Product} product
     */
    saveRecentlyVisitedProductInStorage(product) {
      if (!product) return;
      /**
       * @type {Product[]}
       */
      let recentlyVisitedProducts = this.getRecentlyVisitedItemsFromStorage();

      recentlyVisitedProducts = recentlyVisitedProducts.filter((item) => {
        return item.handle !== product.handle;
      });

      recentlyVisitedProducts = [{ ...product }, ...recentlyVisitedProducts];
      localStorage.setItem(
        "recently-visited-guest",
        JSON.stringify(recentlyVisitedProducts)
      );
    },
    saveRecentlyVisitedProduct(product) {
      if (_customerId) {
        return this.saveRecentlyVisitedProductInDB(
          product.handle,
          product.variantId
        );
      }

      this.saveRecentlyVisitedProductInStorage(product);
    },
    /**
     * @returns {Promise<Product[]>}
     */
    getHistoryItems() {
      if (_customerId) {
        return this.fetchRecentlyVisitedProducts(1, 20).then((res) => {
          return (
            res?.data?.map((item) => ({
              handle: item.handle.split("?")[0] || "",
              imgUrl: item.image_url,
              price: item.min_price,
              title: item.title,
              hasBasicColors: item.has_basic_colors,
              variantId: item.handle.split("?")[1] || "",
              sale_price: item.sale_price
            })) || []
          );
        });
      }

      return new Promise((res) => {
        res(this.getRecentlyVisitedItemsFromStorage());
      });
    },
  };

  const favourite = {
    /**
     * @returns {Promise<number>} 
     */
    getFavCount:()=> {
      if(_customerId){
        return fetch(`${mainPoint}favorite/count?customerId=${_customerId}&date=${tokenDate}`,{
          headers: {
            "X-Shopify-Token": token,
          },
        })
        .then((res)=> res.json())
        .then((res)=> {
          return res.count;
        });
      }

      const favs = JSON.parse(localStorage.getItem("favourites") || "[]") || [];
      return new Promise((res)=> {
        res(favs.length)
      })
    }, 
    getFavouritesFromDB: (page = 1, perPage = 20) => {
      return fetch(
        `${mainPoint}favorite?page=${page}&customerId=${_customerId}&date=${tokenDate}&perPage=${perPage}`,
        {
          headers: {
            "X-Shopify-Token": token,
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (!res?.data) return res;

          res.data = res?.data?.map((item) => ({
            handle: item.handle.split("?")[0],
            hasBasicColors: item.has_basic_colors,
            variant: item.handle.split("?")[1],
            price: item.min_price,
            imageUrl: item.image_url,
            title: item.title,
          }));

          return res;
        });
    },
    /**
     *
     * @param {string} handle
     * @param {string} queryParam
     * @returns {Promise<"added" | "removed">}
     */
    toggleFavouritesInDB: (handle, queryParam) => {
      return fetch(`${mainPoint}favorite`, {
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Token": token,
        },
        method: "POST",
        body: JSON.stringify({
          pageHandle: handle,
          queryParam: String(queryParam),
          data: {
            userId: Number(_customerId),
            date: String(tokenDate),
          },
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          return res.result.status === "fav-removed" ? "removed" : "added";
        });
    },
    /**
     * @returns {{data:Favourite[], count:number, page:number}}
     */
    getFavouritesFromStorage(page = 1, perPage = 1000) {
      const favs = JSON.parse(localStorage.getItem("favourites") || "[]");

      const startIndex = (page - 1) * perPage;
      const endIndex = page * perPage;
      return {
        data: favs.slice(startIndex, endIndex) || [],
        count: favs.length,
        page,
      };
    },
    /**
     * @param {Favourite} favourite
     * @returns {"added" | "removed"}
     */
    toggleFavouritesInStorage(favourite) {
      let favourites = this.getFavouritesFromStorage(1, 1000)?.data || [];

      let filteredFavs = favourites.filter((item) => {
        return (
          item.handle + (item.variant || "") != favourite.handle + (favourite.variant || "")
        );
      });

      // if favourite already existed
      if (filteredFavs.length < favourites.length) {
        localStorage.setItem("favourites", JSON.stringify(filteredFavs));
        return "removed";
      }

      // if favourite didnt exist
      localStorage.setItem(
        "favourites",
        JSON.stringify([favourite, ...favourites])
      );

      return "added";
    },
    bulkFavourite(){
      if(!_customerId){
        return;
      }
      const favourites =  this.getFavouritesFromStorage().data;

      if(favourites?.length < 1){
        return
      }

      const reqBody = {
        bulk: favourites?.map((item)=> {
          let bulkItem = item.handle;

          if(item.variant){
            bulkItem = `${bulkItem}?${item.variant}`
          }
          return bulkItem;
        }).filter(Boolean)
      }

      return fetch(`${mainPoint}favorite/bulk`, {
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Token": token,
        },
        method: "POST",
        body: JSON.stringify({
          bulk: reqBody.bulk,
          data:{
            userId: Number(_customerId),
            date: String(tokenDate),
          },
        }),
      }).then(()=> {
        localStorage.removeItem("favourites")
        favourite.renderFavForCards();
        favourite.renderFavCount();
      }).catch((e)=> {
        console.log({e})
      })
    },
    /**
     * @returns {Promise<{data:Favourite[], count: number, page:number}>}
     */
    getFavourites(page = 1, perPage = 20) {
      if (_customerId) {
        return this.getFavouritesFromDB(page, perPage);
      }

      return new Promise((res) => {
        res(this.getFavouritesFromStorage(page, perPage));
      });
    },
    /**
     * @param {Favourite} favourite
     * @returns {Promise<"added" | "removed">}
     */
    toggleFavourites(favourite) {
      if (_customerId) {
        return this.toggleFavouritesInDB(
          favourite.handle,
          favourite.variant
        ).then((res) => {
          this.renderFavCount();
          return res;
        });
      }

      return new Promise((res) => {
        res(this.toggleFavouritesInStorage(favourite));
      }).then((res) => {
        this.renderFavCount();
        return res;
      });
    },
    /**
     * @param {number[]} variantIds
     * @returns {Promise<number[]>}
     * Works in localstorage,
     * Takes in list of variant(or collections) id arrays and returns those variants which are favourites
     */
    filterFavouriteVariantsFromStorage(variantIds) {
      /**
       * @type {Favourite[]}
       */
      const favourites = this.getFavouritesFromStorage()?.data || [];
      return new Promise((res) => {
        res(
          variantIds.filter((id) =>
            favourites.some((fav) => {

              if (fav.variant) {
                return fav.variant == id;
              }
              return fav.handle.split("_")[1] == id;
            })
          )
        );
      });
    },
    /**
     * @param {number[]} variantIds
     * @returns {Promise<number[]>}
     * Calls api
     * Takes in list of variant(or collections) id arrays and returns those variants which are favourites
     */
    filterFavouriteVariantsFromDB(variantIds) {
      if (!_customerId) {
        return new Promise((res) => res([]));
      }

      return fetch(`${mainPoint}favorite/check`, {
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Token": token,
        },
        method: "POST",
        body: JSON.stringify({
          ids: variantIds,
          data: {
            userId: Number(_customerId),
            date: String(tokenDate),
          },
        }),
      })
        .then((res) => res.json())
        .then((res) => res?.data || []);
    },
    /**
     * @param {number[]} variantIds
     * @returns {Promise<number[]>}
     * Handles storage cases and api cases.
     * Takes in list of variant(or collections) id arrays and returns those variants which are favourites
     */
    filterFavouriteVariants(variantIds) {
      if (!_customerId) {
        return this.filterFavouriteVariantsFromStorage(variantIds);
      }

      return this.filterFavouriteVariantsFromDB(variantIds);
    },
    /**
     * Checks if product is favourite or not.
     * @param {number} variantId variant/collection id to check
     * @returns {Promise<boolean>}
     */
    checkIfProductIsFav(variantId) {
      if (_customerId) {
        return this.filterFavouriteVariantsFromDB([String(variantId)]).then(
          (res) => {
            if (res.length === 1) {
              return true;
            }
            return false;
          }
        );
      }

      return this.filterFavouriteVariantsFromStorage([String(variantId)]).then(
        (res) => {
          if (res.length === 1) {
            return true;
          }
          return false;
        }
      );
    },
    /**
     * @param {HTMLElement} card
     * @param {boolean} fav
     */
    setFavOnCard(card, fav){
      let favHeart = card.querySelector(".fav-heart__container");

      if (fav) {
        favHeart.querySelector("path").setAttribute("fill", "#DDC248");
      } else {
        favHeart.querySelector("path").setAttribute("fill", "none");
      }
    },
    addListenerForFav(){
      const productCards = Array.from(
        document.querySelectorAll('[data-component="product-card"]') || []
      );

      productCards.forEach((card)=> {
        const collId = card.dataset.collid;
        const variantId = card.dataset.variantid;
        const cardId = variantId || collId || null;
        const imageURL = card.dataset.imageurl;
        const title = card.dataset.title;
        const price = card.dataset.price;
        let favHeart = card.querySelector(".fav-heart__container");

        favHeart.onclick = (e) => {
          e?.stopPropagation();
          e?.preventDefault();
          const isFavBeforeClick = favHeart.querySelector('path').getAttribute('fill') == "none" ? false : true
          const isFav = !isFavBeforeClick;

          // optimistic update on count
          if(isFav){
            favourite.changeFavCountOptimistic("inc")
          }else{
            favourite.changeFavCountOptimistic("dec")
          }

          // optimistic update on all cards
          // last two lines of selector are for Cases where  cardid is collectionid and variant id is not present
          let selector = `
            [data-component="product-card"][data-variantid="${cardId}"], 
            [data-component="product-card"][data-variantid=""][data-collid="${cardId}"], 
            [data-component="product-card"]:not([data-variantid])[data-collid="${cardId}"]
          `;
          const cardsWithSameIds = document.querySelectorAll(selector)

          cardsWithSameIds.forEach((card)=> {
            favourite.setFavOnCard(card, isFav)
          })

          favourite
            .toggleFavourites({
              handle: "collection_" + collId,
              variant: variantId,
              imageUrl: imageURL,
              title,
              price,
            })
            .then((res) => {
              const isFav = res === "added";
              
              cardsWithSameIds.forEach((card)=> {
                favourite.setFavOnCard(card, isFav)
              })
            })
        };
      })
    },
    markIfFavourite(){
      const productCards = Array.from(
        document.querySelectorAll('[data-component="product-card"]') || []
      );
      const ids = productCards
      .map((item) => {
        return item.dataset.variantid || item.dataset.collid || null;
      })
      .filter(Number);

      this.filterFavouriteVariants(ids).then((favs) => {
        productCards.forEach((card) => {
          const collId = card.dataset.collid;
          const variantId = card.dataset.variantid;
          const cardId = variantId || collId || null;
          let favHeart = card.querySelector(".fav-heart__container");

          if (favs.includes(cardId)) {
            favHeart.querySelector("path").setAttribute("fill", "#DDC248");
          } else {
            favHeart.querySelector("path").setAttribute("fill", "none");
          }
        });
        this.addListenerForFav();
      });
    },
    /**
     * For optimistic update.
     * @param {"inc" | "dec"} inc 
     */
    changeFavCountOptimistic(inc){
      const favCountBubble = document.getElementById("fav-count-bubble");
      let count = Number(favCountBubble.textContent || 0)

      if(favCountBubble.dataset.isCountFetched != "true"){
        return;
      }

      if(inc == "inc"){
        count+=1;
      }else if (count !== 0){
        count-=1;
      }

      favCountBubble.querySelector('.fav-count-bubble-content').textContent = count

      if (count > 0) {
        favCountBubble.style.visibility = "visible";
        return;
      }

      if(count === 0){
        favCountBubble.style.visibility = "hidden";
      }
    }, 
    renderFavForCards() {
      this.markIfFavourite();
    },
    renderFavCount() {
      return this.getFavCount().then((count) => {
        const favCountBubble = document.getElementById("fav-count-bubble");

        if(favCountBubble?.dataset?.isCountFetched){
          favCountBubble.dataset.isCountFetched = "true"
        }

        if (count > 0) {
          favCountBubble.style.visibility = "visible";
          favCountBubble.querySelector('.fav-count-bubble-content').textContent = count
          return;
        }

        if(count === 0){
          favCountBubble.style.visibility = "hidden";
        }
      });
    },
  };

  // todo move this somewhere
  window.addEventListener("load", () => {
    favourite.renderFavForCards();
    favourite.renderFavCount();
    favourite.bulkFavourite()
  });

  window._Services = {
    viewingHistory,
    favourite,
  };
})();
